class AvoriaCurrencySelector extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.querySelectorAll('button[name="country_code"]').forEach((button) => {
      button.addEventListener('click', () => this.#rememberManualChoice());
    });

    if (window.Shopify?.designMode || this.#hasManualChoice()) return;
    this.#applyDetectedCountry();
  }

  #hasManualChoice() {
    try {
      return window.localStorage.getItem('avoria-country-manual') === 'true';
    } catch {
      return false;
    }
  }

  #rememberManualChoice() {
    try {
      window.localStorage.setItem('avoria-country-manual', 'true');
    } catch {
      // Localization still works when browser storage is unavailable.
    }
  }

  async #applyDetectedCountry() {
    const currentCountry = this.dataset.currentCountry;
    const root = window.Shopify?.routes?.root || '/';
    const query = new URLSearchParams({
      'country[enabled]': 'true',
      'country[exclude]': currentCountry,
      'language[enabled]': 'false',
    });

    try {
      const response = await fetch(`${root}browsing_context_suggestions.json?${query}`);
      if (!response.ok) return;

      const data = await response.json();
      const detectedCountry = data.detected_values?.country?.handle;
      if (!detectedCountry) return;

      const targetCountry = ['CA', 'US'].includes(detectedCountry) ? 'CA' : 'GB';
      if (targetCountry === currentCountry) return;

      const option = this.querySelector(`button[name="country_code"][value="${targetCountry}"]`);
      option?.form?.requestSubmit(option);
    } catch {
      // Keep the current Shopify market if detection is unavailable.
    }
  }
}

if (!customElements.get('avoria-currency-selector')) {
  customElements.define('avoria-currency-selector', AvoriaCurrencySelector);
}
